/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material Picker
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// Date Fns
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { valuesFromToIoSoDate } from 'helpers';

export type PickerVariant = 'dialog' | 'inline' | 'static';

export interface WeekDayProps {
  disabled?: boolean;
  value: Date | string | null;
  classStyle?: string;
  onChange: (date: Date | null) => void;
  variant?: PickerVariant;
  label?: string | null;
  inputVariant?: 'standard' | 'filled' | 'outlined' | undefined;
  positionIcon?: 'start' | 'end' | undefined;
  icon?: React.ReactNode | undefined;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string | null;
  positionDilog?: boolean | undefined;
  openOnInputClick?: boolean;
}

const SelectWeekDay: React.FC<WeekDayProps> = ({
  value,
  disabled,
  onChange,
  variant,
  label,
  inputVariant,
  classStyle,
  positionIcon,
  icon,
  minDate,
  maxDate,
  placeholder,
  positionDilog,
  openOnInputClick,
}) => {
  const [open, setOpen] = React.useState(false);

  let crYear = 0;
  let crMonth = 0;
  let crDay = 0;
  let newValue: Date | string | null = new Date();
  if (typeof value === 'string') {
    if (value.includes('T')) {
      const { year, month, day } = valuesFromToIoSoDate(value);
      crYear = year;
      crMonth = month;
      crDay = day;
    } else {
      const dateParts = value.split('/');
      crDay = Number(dateParts[0]);
      crMonth = Number(dateParts[1]);
      crYear = Number(dateParts[2]);
    }
    newValue = new Date(crYear, crMonth - 1, crDay).toDateString();
  } else {
    newValue = value;
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <KeyboardDatePicker
        className={classStyle}
        disabled={!!disabled}
        placeholder={placeholder || ''}
        autoOk
        disableToolbar
        format='dd/MM/yyyy'
        onChange={onChange}
        value={newValue}
        inputVariant={inputVariant}
        variant={variant}
        label={label}
        keyboardIcon={icon}
        cancelLabel='Cancelar'
        okLabel='OK'
        clearLabel='Limpar'
        todayLabel='Hoje'
        invalidDateMessage='Data inválida'
        minDateMessage='Data deve ser igual ou posterior à data mínima'
        maxDateMessage='Data deve ser igual ou anterior à data máxima'
        minDate={minDate}
        maxDate={maxDate}
        DialogProps={positionDilog ? { style: { bottom: '26vh' } } : undefined}
        InputAdornmentProps={{
          position: positionIcon,
        }}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onClick={
          openOnInputClick && !disabled ? () => setOpen(true) : undefined
        }
      />
    </MuiPickersUtilsProvider>
  );
};

export default SelectWeekDay;
export { SelectWeekDay };
